__turbopack_context__.v({
  "badgeLogo": "Category-module__7GiyGq__badgeLogo",
  "brandBadge": "Category-module__7GiyGq__brandBadge",
  "catBottom": "Category-module__7GiyGq__catBottom",
  "catCard": "Category-module__7GiyGq__catCard",
  "catGrid": "Category-module__7GiyGq__catGrid",
  "catHeader": "Category-module__7GiyGq__catHeader",
  "catHeaderInner": "Category-module__7GiyGq__catHeaderInner",
  "catHeaderTitle": "Category-module__7GiyGq__catHeaderTitle",
  "catImg": "Category-module__7GiyGq__catImg",
  "catImgWrap": "Category-module__7GiyGq__catImgWrap",
  "catName": "Category-module__7GiyGq__catName",
  "catSectionLabel": "Category-module__7GiyGq__catSectionLabel",
  "catUnderline": "Category-module__7GiyGq__catUnderline",
  "ctaBtn": "Category-module__7GiyGq__ctaBtn",
  "ctaWrap": "Category-module__7GiyGq__ctaWrap",
});
